exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\ndiv.tile {\n  position: relative;\n  float: left;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\ndiv.tile div.photo {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  transition: -webkit-transform 0.5s ease-out;\n  transition: transform 0.5s ease-out;\n  transition: transform 0.5s ease-out, -webkit-transform 0.5s ease-out;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/artur/workspace/vscode/warpriders/src/app/content/libs/image-zoom/image-zoom.component.less
// module id = ../../../../../src/app/content/libs/image-zoom/image-zoom.component.less
// module chunks = 1